import React, { useEffect, useState } from "react";
const API_BASE = process.env.REACT_APP_API_URL;
const fmt = (val, digits = 2) => {
  const num = Number(val);
  return isNaN(num) ? "0.00" : num.toFixed(digits);
};

const formatDate = (dateStr) => {
  try {
    return new Date(dateStr).toLocaleDateString("en-GB");
  } catch {
    return dateStr;
  }
};

const CollectionTable = ({ title, data }) => {
  // totals + weighted averages
  const totals = data.reduce(
    (acc, row) => {
      const qty = Number(row.qty) || 0;
      const fat = Number(row.fat) || 0;
      const snf = Number(row.snf) || 0;
      const rate = Number(row.rate) || 0;
      const amount = Number(row.baseamt) || 0;

      acc.totalQty += qty;
      acc.totalAmount += amount;
      acc.fatSum += qty * fat;
      acc.snfSum += qty * snf;
      acc.rateSum += qty * rate;
      return acc;
    },
    { totalQty: 0, totalAmount: 0, fatSum: 0, snfSum: 0, rateSum: 0 }
  );

  const avgFat = totals.totalQty ? totals.fatSum / totals.totalQty : 0;
  const avgSnf = totals.totalQty ? totals.snfSum / totals.totalQty : 0;
  const avgRate = totals.totalQty ? totals.rateSum / totals.totalQty : 0;

  return (
    <div style={{ marginBottom: "2rem" }}>
      <h2 style={{ fontSize: "1.2rem", marginBottom: "0.5rem" }}>{title}</h2>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          fontSize: "0.95rem",
          backgroundColor: "#fff",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#f0f8f5" }}>
            <th style={thStyle}>दिनांक</th>
            <th style={thStyle}>वेळ</th>
            <th style={thStyle}>लिटर्स</th>
            <th style={thStyle}>Fat</th>
            <th style={thStyle}>SNF</th>
            <th style={thStyle}>दर</th>
            <th style={thStyle}>रक्कम</th>
          </tr>
        </thead>
        <tbody>
          {data.map((entry, index) => (
            <tr key={index}>
              <td style={tdStyle}>{formatDate(entry.tran_date)}</td>
              <td style={tdStyle}>
                {entry.shift_code === 1 || entry.shift_code === "1"
                  ? "सकाळ"
                  : "सायं"}
              </td>
              <td style={tdStyle}>{fmt(entry.qty, 3)}</td>
              <td style={tdStyle}>{fmt(entry.fat, 1)}</td>
              <td style={tdStyle}>{fmt(entry.snf, 1)}</td>
              <td style={tdStyle}>₹{fmt(entry.rate)}</td>
              <td style={tdStyle}>₹{fmt(entry.baseamt)}</td>
            </tr>
          ))}

          {/* Totals row */}
          <tr style={{ backgroundColor: "#eef7ee", fontWeight: "bold" }}>
            <td style={tdStyle} colSpan={2}>
              एकूण / सरासरी
            </td>
            <td style={tdStyle}>{fmt(totals.totalQty, 3)}</td>
            <td style={tdStyle}>{fmt(avgFat, 2)}</td>
            <td style={tdStyle}>{fmt(avgSnf, 2)}</td>
            <td style={tdStyle}>₹{fmt(avgRate, 2)}</td>
            <td style={tdStyle}>₹{fmt(totals.totalAmount, 2)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const thStyle = {
  border: "1px solid #ccc",
  padding: "0.5rem",
  textAlign: "center",
};

const tdStyle = {
  border: "1px solid #ccc",
  padding: "0.5rem",
  textAlign: "center",
};

const SankalanTab = ({ fromDate, toDate }) => {
  const [cowData, setCowData] = useState([]);
  const [buffaloData, setBuffaloData] = useState([]);
  const [loading, setLoading] = useState(false);

  const farmerUsername = localStorage.getItem("farmerUsername") || "F-B-3";

  useEffect(() => {
    const fetchCollection = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${API_BASE}/getTransactions`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            username: farmerUsername,
            from_date: fromDate,
            to_date: toDate,
            trantype: "COLLECTION",
            group_by_type: false,
          }),
        });

        if (!res.ok) throw new Error("Failed to fetch");
        const data = await res.json();

        const transactions = data.transactions || [];

        // split cow vs buffalo (milktypecode = 1 => cow, 2 => buffalo)
        const cow = transactions.filter(
          (t) => t.milktypecode === 1 || t.milktypecode === "1"
        );
        const buffalo = transactions.filter(
          (t) => t.milktypecode === 2 || t.milktypecode === "2"
        );

        setCowData(cow);
        setBuffaloData(buffalo);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCollection();
  }, [fromDate, toDate, farmerUsername]);

  return (
    <div
      style={{
        height: "calc(100vh - 120px)",
        overflowY: "auto",
        padding: "1rem",
        fontFamily: "Mukta, sans-serif",
        backgroundColor: "#f9f9f9",
      }}
    >
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          <CollectionTable title="🐄 गाय संकलन" data={cowData} />
          <CollectionTable title="🐃 म्हैस संकलन" data={buffaloData} />
        </>
      )}
    </div>
  );
};

export default SankalanTab;
